const WT_INLINE_ALERT_DEBUG = true;
const wtInlineAlertDebug = (message, payload = undefined) => {
  if (!WT_INLINE_ALERT_DEBUG) return;
  const prefix = "[product-form:inline-alert]";
  if (payload !== undefined) {
    console.warn(`${prefix} ${message}`, payload);
    return;
  }
  console.warn(`${prefix} ${message}`);
};

wtInlineAlertDebug("script_loaded", {
  href: window.location.href,
  alreadyDefined: Boolean(customElements.get("product-form")),
});

document.addEventListener(
  "submit",
  (event) => {
    if (!WT_INLINE_ALERT_DEBUG) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!String(form.action || "").includes("/cart/add")) return;
    wtInlineAlertDebug("global_submit_capture", {
      action: form.action,
      id: form.id || null,
      className: form.className || null,
      insideProductForm: Boolean(form.closest("product-form")),
    });
  },
  true,
);

document.addEventListener(
  "click",
  (event) => {
    if (!WT_INLINE_ALERT_DEBUG) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('button[name="add"], .product-form__submit');
    if (!(button instanceof HTMLButtonElement)) return;

    const form = button.form || button.closest("form");
    wtInlineAlertDebug("global_click_add_button", {
      text: (button.textContent || "").trim().slice(0, 80),
      id: button.id || null,
      type: button.getAttribute("type") || null,
      disabled: button.disabled,
      ariaDisabled: button.getAttribute("aria-disabled"),
      formAction: form?.action || null,
      insideProductForm: Boolean(button.closest("product-form")),
    });
  },
  true,
);

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType || "page";

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.openAccordionAncestors = this.openAccordionAncestors.bind(this);
        this.extractErrorMessage = this.extractErrorMessage.bind(this);
        this.getValidationErrorFromScope = this.getValidationErrorFromScope.bind(this);
        this.logInlineAlertDebug = this.logInlineAlertDebug.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      logInlineAlertDebug(message, payload = undefined) {
        if (!WT_INLINE_ALERT_DEBUG) return;
        const prefix = "[product-form:inline-alert]";
        if (payload !== undefined) {
          console.warn(`${prefix} ${message}`, payload);
          return;
        }
        console.warn(`${prefix} ${message}`);
      }

      connectedCallback() {
        const form = this.querySelector("form");
        this.logInlineAlertDebug("connectedCallback", {
          section: this.closest("[data-section-id]")?.dataset?.sectionId || null,
          hasForm: Boolean(form),
          hasSubmitButton: Boolean(this.querySelector('[type="submit"]')),
          formAction: form?.action || null,
        });

        if (form && !this._inlineAlertFormDebugBound) {
          this._inlineAlertFormDebugBound = true;
          this._submitObservedSinceLastClick = false;

          form.addEventListener(
            "submit",
            () => {
              this._submitObservedSinceLastClick = true;
              this.logInlineAlertDebug("form_submit_capture");
            },
            true,
          );

          form.addEventListener(
            "invalid",
            (event) => {
              const field = event.target;
              this.logInlineAlertDebug("form_invalid_capture", {
                tagName: field?.tagName || null,
                name: field?.getAttribute?.("name") || null,
                id: field?.id || null,
                type: field?.getAttribute?.("type") || null,
                validationMessage: field?.validationMessage || null,
              });
            },
            true,
          );
        }

        if (this.submitButton && !this._inlineAlertButtonDebugBound) {
          this._inlineAlertButtonDebugBound = true;
          this.submitButton.addEventListener(
            "click",
            (event) => {
              this._submitObservedSinceLastClick = false;
              this.logInlineAlertDebug("button_click_capture", {
                defaultPrevented: event.defaultPrevented,
                cancelBubble: event.cancelBubble,
              });

              setTimeout(() => {
                if (!this._submitObservedSinceLastClick) {
                  this.logInlineAlertDebug("submit_not_observed_after_click", {
                    buttonDisabled: this.submitButton?.disabled || false,
                    ariaDisabled:
                      this.submitButton?.getAttribute("aria-disabled") || null,
                    formAction: this.form?.action || null,
                  });
                }
              }, 0);
            },
            true,
          );

          this.submitButton.addEventListener("click", (event) => {
            this.logInlineAlertDebug("button_click_bubble", {
              defaultPrevented: event.defaultPrevented,
              cancelBubble: event.cancelBubble,
            });
          });
        }

      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.logInlineAlertDebug("submit:start", {
          section: this.closest("[data-section-id]")?.dataset?.sectionId || null,
          hideErrors: this.hideErrors,
          hasSubmitButton: Boolean(this.submitButton),
        });
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
        } else {
          formData.append("sections", []);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            this.logInlineAlertDebug("cart_add:response", response);
            if (response.status) {
              const errorMessage = this.extractErrorMessage(response);
              this.logInlineAlertDebug("cart_add:error", {
                status: response.status,
                errorMessage,
              });
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || errorMessage,
                message: response.message,
              });
              this.handleErrorMessage(errorMessage);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

              this.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  detail: { response: response },
                  bubbles: true,
                  composed: true,
                }),
              );

              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              this.logInlineAlertDebug("cart_add:success:redirect_to_cart_page");
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            this.logInlineAlertDebug("cart_add:success", {
              hasCartDrawer: Boolean(this.cart),
              cartType: this.cartType,
            });
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            this.logInlineAlertDebug("cart_add:exception", {
              name: e?.name,
              message: e?.message,
            });
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      extractErrorMessage(response = {}) {
        this.logInlineAlertDebug("extractErrorMessage:input", response);
        if (!response || typeof response !== "object") return "";
        if (typeof response.description === "string" && response.description.trim()) {
          return response.description.trim();
        }
        if (typeof response.message === "string" && response.message.trim()) {
          return response.message.trim();
        }
        if (Array.isArray(response.errors)) {
          const listError = response.errors.find(
            (item) => typeof item === "string" && item.trim(),
          );
          if (listError) return listError.trim();
        }
        if (response.errors && typeof response.errors === "object") {
          for (const value of Object.values(response.errors)) {
            if (typeof value === "string" && value.trim()) {
              return value.trim();
            }
            if (Array.isArray(value)) {
              const nestedValue = value.find(
                (item) => typeof item === "string" && item.trim(),
              );
              if (nestedValue) return nestedValue.trim();
            }
          }
        }
        return "";
      }

      getValidationErrorFromScope(scope) {
        if (!scope || !(scope instanceof Element || scope instanceof Document)) {
          return null;
        }

        const errorNode =
          scope.querySelector(".validation-advice") ||
          scope.querySelector(".mage-error") ||
          scope.querySelector(".field-error");
        if (errorNode) {
          const text = (errorNode.textContent || "").replace(/\s+/g, " ").trim();
          return { node: errorNode, message: text };
        }

        const invalidNode = scope.querySelector('[aria-invalid="true"]');
        if (invalidNode) {
          const fallbackText =
            invalidNode.getAttribute("data-msg-required") ||
            invalidNode.getAttribute("data-msg") ||
            invalidNode.validationMessage ||
            "";
          return {
            node: invalidNode,
            message: (fallbackText || "").replace(/\s+/g, " ").trim(),
          };
        }

        return null;
      }

      openAccordionAncestors(element) {
        if (!element || typeof element.closest !== "function") return;
        let panel = element.closest("collapsible-section");
        let openedCount = 0;

        while (panel) {
          if (panel.dataset.open !== "true") panel.dataset.open = "true";
          const trigger = panel.querySelector(".wt-collapse__trigger");
          if (trigger) {
            trigger.classList.add("wt-collapse__trigger--active");
            trigger.setAttribute("aria-expanded", "true");
          }
          openedCount += 1;
          panel = panel.parentElement?.closest("collapsible-section");
        }
        this.logInlineAlertDebug("openAccordionAncestors:done", { openedCount });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          this.logInlineAlertDebug("handleErrorMessage:skipped_hideErrors_true");
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper[role="alert"]') ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) {
          this.logInlineAlertDebug("handleErrorMessage:no_wrapper_found");
          return;
        }
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        const messageText =
          typeof errorMessage === "string" ? errorMessage.trim() : "";
        const hasMessage = Boolean(messageText);
        this.logInlineAlertDebug("handleErrorMessage:state", {
          inputErrorMessage: errorMessage,
          normalizedMessage: messageText,
          hasMessage,
          wrapperHiddenBefore: this.errorMessageWrapper.hasAttribute("hidden"),
          hasMessageNode: Boolean(this.errorMessage),
        });
        this.errorMessageWrapper.toggleAttribute("hidden", !hasMessage);

        if (hasMessage && this.errorMessage) {
          this.openAccordionAncestors(this.errorMessageWrapper);
          this.errorMessage.textContent = messageText;
          this.logInlineAlertDebug("handleErrorMessage:shown", {
            wrapperHiddenAfter: this.errorMessageWrapper.hasAttribute("hidden"),
            textContent: this.errorMessage.textContent,
          });
        } else if (this.errorMessage) {
          this.errorMessage.textContent = "";
          this.logInlineAlertDebug("handleErrorMessage:hidden", {
            wrapperHiddenAfter: this.errorMessageWrapper.hasAttribute("hidden"),
          });
        }
      }
    },
  );
}
